import * as PharmaActions from "../actions/pharma-page.actions";
import { PharmaDatabasePage } from "../models/pharma-page-store.model";

const initialState: PharmaDatabasePage = {
  chartFilters: {
    company_id: "",
    therapeutic_area: "",
    indication: "",
    moa: "",
    phase: "",
    target: "",
    geo: "",
    commercial_status: "",
  },
  facetFilters: {
    company_id: [],
    therapeutic_area: [],
    indication: [],
    moa: [],
    phase: [],
    drug_class: [],
    api: [],
    drug: [],
    target: [],
    geo: [],
    commercial_status: [],
    include_terminated: false,
    peak_sales: {},
    drug_revenue: {},
    approval_date: {},
    expiry_date: {},
    launch_year: {},
    market_cap: {},
    rating: {},
    drugType: [],
    delivery_mechanism: [],
    parent_co_financials: {},
    valuation_ratios: {},
    price_target: {},
  },
  lastFacetFilter: {
    company_id: [],
    therapeutic_area: [],
    indication: [],
    moa: [],
    phase: [],
    drug_class: [],
    api: [],
    drug: [],
    target: [],
    geo: [],
    commercial_status: [],
    include_terminated: false,
    peak_sales: {},
    drug_revenue: {},
    approval_date: {},
    expiry_date: {},
    launch_year: {},
    market_cap: {},
    rating: {},
    drugType: [],
    delivery_mechanism: [],
    parent_co_financials: {},
    valuation_ratios: {},
    price_target: {},
  },
  pillsData: {
    tags: [],
    extraInfo: {},
  },
  gridSettings: {},
  savedFilter: {
    filter_id: null,
    filter_name: "",
    json_data: {},
  },
  filterEvent: {
    filterChanged: "",
    source: "",
  },
};

function pillsDelete(pillInfo, stateObj) {
  const tagInfo = pillInfo;
  let category = tagInfo["key"];
  const id = tagInfo["id"];
  if (category === "company_id") {
    category = "ticker";
  }
  const facetFilterObjClone = { ...stateObj.facetFilters };
  if (category === "include_terminated") {
    //for any future Boolean filters added
    facetFilterObjClone[tagInfo["key"]] = false;
    //special handlind for include_terminated pill close
    facetFilterObjClone["phase"] = facetFilterObjClone["phase"].filter(
      function (item) {
        return item !== "Terminated";
      },
    );
    facetFilterObjClone["commercial_status"] = facetFilterObjClone[
      "commercial_status"
    ].filter(function (item) {
      return item !== "Discontinued";
    });
  } else {
    facetFilterObjClone[tagInfo["key"]] = facetFilterObjClone[
      tagInfo["key"]
    ].filter(function (item) {
      return item !== id;
    });
  }
  stateObj.facetFilters = { ...facetFilterObjClone };
  const clone = Object.assign({}, stateObj.facetFilters);
  stateObj.lastFacetFilter = { ...clone };
  stateObj.chartFilters = { ...initialState.chartFilters };
  // reading tags name and id and adding to extra info
  const pillsData = JSON.parse(JSON.stringify(stateObj.pillsData));
  Object.values(pillsData.tags).forEach((element) => {
    if (element["id"] === "include_terminated") {
      return;
    }
    if (element["key"] === "company_id") {
      Object.assign(pillsData.extraInfo["ticker_data"], {
        [element["id"]]: element["label"],
      });
    } else {
      Object.assign(pillsData.extraInfo[`${element["key"]}_data`], {
        [element["id"]]: element["label"],
      });
    }
  });
  stateObj.pillsData = JSON.parse(JSON.stringify(pillsData));
}
function chartFilterAdded(payload, state) {
  // const clone = Object.assign({}, state.facetFilters);
  // state.lastFacetFilter = { ...clone };
  const chartFilters = payload.data.chartFilters;
  if (
    chartFilters["company_id"] &&
    payload.data.extraInfo &&
    payload.data.extraInfo.ticker_data
  ) {
    state.facetFilters.company_id = [];
    state.facetFilters.company_id.push(chartFilters["company_id"]);
    const ticker =
      payload.data.extraInfo.ticker_data[chartFilters["company_id"]];
    if (ticker) {
      if (!state.pillsData.extraInfo["ticker_data"]) {
        state.pillsData = {
          ...state.pillsData,
          extraInfo: {
            ...state.pillsData.extraInfo,
            ticker_data: {},
          },
        };
      }
      state.pillsData = {
        ...state.pillsData,
        extraInfo: {
          ...state.pillsData.extraInfo,
          ticker_data: {
            ...state.pillsData.extraInfo.ticker_data,
            [chartFilters["company_id"]]: ticker,
          },
        },
      };
    }
  }
  if (
    chartFilters["phase"] &&
    payload.data.extraInfo &&
    payload.data.extraInfo.phase_data
  ) {
    state.facetFilters.phase = [];
    state.facetFilters.phase.push(chartFilters["phase"]);
    state.pillsData = {
      ...state.pillsData,
      extraInfo: {
        ...state.pillsData.extraInfo,
        phase_data: {
          ...payload.data.extraInfo.phase_data,
        },
      },
    };
  }
  if (
    chartFilters["indication"] &&
    payload.data.extraInfo &&
    payload.data.extraInfo.indication_data
  ) {
    state.facetFilters.indication = [];
    state.facetFilters.indication.push(chartFilters["indication"]);
    state.pillsData = {
      ...state.pillsData,
      extraInfo: {
        ...state.pillsData.extraInfo,
        indication_data: {
          ...payload.data.extraInfo.indication_data,
        },
      },
    };
  }
  if (
    chartFilters["moa"] &&
    payload.data.extraInfo &&
    payload.data.extraInfo.moa_data
  ) {
    state.facetFilters.moa = [];
    state.facetFilters.moa.push(chartFilters["moa"]);
    state.pillsData = {
      ...state.pillsData,
      extraInfo: {
        ...state.pillsData.extraInfo,
        moa_data: {
          ...payload.data.extraInfo.moa_data,
        },
      },
    };
  }
  if (chartFilters["target"]) {
    state.facetFilters.target = [];
    state.facetFilters.target.push(chartFilters["target"]);
  }
  if (chartFilters["geo"]) {
    state.facetFilters.geo = [];
    state.facetFilters.geo.push(chartFilters["geo"]);
  }
  if (chartFilters["commercial_status"]) {
    state.facetFilters.target = [];
    state.facetFilters.target.push(chartFilters["commercial_status"]);
  }
}

function chartFilterRemoved(payload, state) {
  if (payload.source === "company-deselected") {
    state.facetFilters.company_id.pop();
    state.facetFilters.company_id = [...state.lastFacetFilter.company_id];
  }

  if (payload.source === "phase-deselected") {
    state.facetFilters.phase.pop();
    state.facetFilters.phase = [...state.lastFacetFilter.phase];
  }
  if (payload.source === "indication-deselected") {
    //Chart filter clear scnario. Rmove last entry
    //Always the last entry will be chart filter since applying facet filter from UI will wipe out chart filter
    state.facetFilters.indication.pop();
    state.facetFilters.indication = [...state.lastFacetFilter.indication];
  }
  if (payload.source === "moa-deselected") {
    //Chart filter clear scnario. Rmove last entry
    //Always the last entry will be chart filter since applying facet filter from UI will wipe out chart filter
    state.facetFilters.moa.pop;
    state.facetFilters.moa = [...state.lastFacetFilter.moa];
  }

  if (payload.source === "target-deselected") {
    //Chart filter clear scnario. Rmove last entry
    //Always the last entry will be chart filter since applying facet filter from UI will wipe out chart filter
    state.facetFilters.target.pop;
    state.facetFilters.target = [...state.lastFacetFilter.target];
  }

  if (payload.source === "geo-deselected") {
    //Chart filter clear scnario. Rmove last entry
    //Always the last entry will be chart filter since applying facet filter from UI will wipe out chart filter
    state.facetFilters.geo.pop;
    state.facetFilters.geo = [...state.lastFacetFilter.geo];
  }

  if (payload.source === "commercial_status-deselected") {
    //Chart filter clear scnario. Rmove last entry
    //Always the last entry will be chart filter since applying facet filter from UI will wipe out chart filter
    state.facetFilters.commercial_status.pop;
    state.facetFilters.commercial_status = [
      ...state.lastFacetFilter.commercial_status,
    ];
  }
}

function updatePillData(facetFilterDTO, extraInfo) {
  let res = [];
  for (const key in facetFilterDTO) {
    if (key === "company_id") {
      res = res.concat(
        facetFilterDTO.company_id.map((id) => {
          return {
            id: id,
            label: extraInfo["ticker_data"][id],
            key: key,
          };
        }),
      );
    }
    // else if (key === "drug") {
    //   res = res.concat(
    //     facetFilterDTO.drug.map((id) => {
    //       return {
    //         id: id,
    //         label: extraInfo["drug_data"] ? extraInfo["drug_data"][id] : "",
    //         key: key,
    //       };
    //     }),
    //   );
    // }
    else if (key === "include_terminated") {
      if (facetFilterDTO[key])
        res = res.concat([
          {
            id: "include_terminated",
            label: "Include Terminated",
            key: "include_terminated",
          },
        ]);
    } else if(key === "peak_sales" || key === "drug_revenue" || key === "approval_date" 
      || key === "expiry_date" || key === "launch_year" || key === "drugType" || key === "parent_co_financials"
      || key === "valuation_ratios" || key === "price_target" || key === "market_cap" || key === "rating") {

    } else {
      res = res.concat(
        facetFilterDTO[key].map((id) => {
          return {
            id: id,
            label: extraInfo[`${key}_data`] ? extraInfo[`${key}_data`][id] : id,
            key: key,
          };
        }),
      );
    }
  }
  return res;
}
function updateState(payload, state) {
  const stateObj = {
    ...state,
  };
  let clone: any = {};
  switch (payload.filterChanged) {
    case "chart":
      if (payload.source.includes("deselected")) {
        stateObj.chartFilters = { ...payload.data.chartFilters };
        stateObj.facetFilters = { ...state.facetFilters };
        chartFilterRemoved(payload, stateObj);
        stateObj.pillsData = {
          ...stateObj.pillsData,
          tags: updatePillData(
            stateObj.facetFilters,
            stateObj.pillsData.extraInfo,
          ),
        };
      } else {
        stateObj.chartFilters = { ...payload.data.chartFilters };
        stateObj.facetFilters = { ...state.facetFilters };
        //stateObj.pillsData = {...state.pillData};
        chartFilterAdded(payload, stateObj);
        stateObj.pillsData = {
          ...stateObj.pillsData,
          tags: updatePillData(
            stateObj.facetFilters,
            stateObj.pillsData.extraInfo,
          ),
        };
      }
      break;
    case "facet":
      stateObj.facetFilters = { ...payload.data.facetFilters };
      stateObj.pillsData = Object.assign({}, stateObj.pillsData);
      stateObj.pillsData.extraInfo = { ...payload.data.extraInfo };
      if (payload.data.fromQueryFilter) {
        stateObj.pillsData.extraInfo["fromQueryFilter"] = true;
      }
      clone = Object.assign({}, stateObj.facetFilters);
      stateObj.lastFacetFilter = { ...clone };
      stateObj.chartFilters = { ...initialState.chartFilters };
      (stateObj.pillsData = {
        ...stateObj.pillsData,
        tags: updatePillData(stateObj.facetFilters, payload.data.extraInfo),
      }),
        (stateObj.savedFilter = payload.data.savedFilter
          ? payload.data.savedFilter
          : state.savedFilter);
      break;
    case "pill":
      if (payload.source === "delete") {
        pillsDelete(payload.pillInfo, stateObj);
        stateObj.pillsData = {
          ...stateObj.pillsData,
          tags: updatePillData(
            stateObj.facetFilters,
            stateObj.pillsData.extraInfo,
          ),
        };
      }
      break;
    case "grid":
      break;
    default:
      // default load
      break;
  }
  return stateObj;
}
export function pharmaDatabasePageReducer(
  state: PharmaDatabasePage = initialState,
  action: PharmaActions.Actions,
) {
  let res = [];
  let updatedStateObj: any = {};
  switch (action.type) {
    case PharmaActions.FACET_FILTER_CHANGED:
      return {
        ...state,
        facetFilters: { ...action.payload },
      };
    case PharmaActions.CHART_FILTER_CHANGED:
      return {
        ...state,
        chartFilters: { ...action.payload },
      };

    case PharmaActions.FILTER_EVENT_CHANGED:
      //update chart and facets based on events
      updatedStateObj = updateState(action.payload, state);
      return {
        ...state,
        filterEvent: { ...action.payload },
        chartFilters: updatedStateObj.chartFilters,
        facetFilters: updatedStateObj.facetFilters,
        pillsData: updatedStateObj.pillsData,
        lastFacetFilter: updatedStateObj.lastFacetFilter,
        savedFilter: updatedStateObj.savedFilter,
      };
    case PharmaActions.SAVED_FILTER_CHANGED:
      return {
        ...state,
        savedFilter: { ...action.payload },
      };
    case PharmaActions.UPDATE_PILLS:
      //add logic to update pills from facets and charts
      res = updatePillData(
        action.payload.facetFilter,
        action.payload.extraInfo,
      );
      return {
        ...state,
        pillsData: { tags: res, extraInfo: state.pillsData.extraInfo },
        filterEvent: {
          filterChanged: "",
          source: "",
        },
      };
    default:
      return state;
  }
}
